import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-paymentfailure',
  templateUrl: './paymentfailure.component.html',
  styleUrls: ['./paymentfailure.component.scss'],
})
export class PaymentfailureComponent {
  showContent = false;
  showButton = false;

  constructor(private router: Router, private toastr: ToastrService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.showContent = true;
    }, 300);

    setTimeout(() => {
      this.showButton = true;
    }, 800);
  }

  retryPayment() {
    console.log('Retrying payment process...');

    this.toastr.info('Redirecting to payment page...', 'Retry Payment');
    this.router.navigateByUrl('/login');
  }

  ContactSupport() {
    console.log('Opening support contact...');

    this.toastr.info('Opening support contact form...', 'Contact Support');
  }

  onGoBack() {
    this.router.navigate(['/']);
  }
}
